module.exports = __webpack_public_path__ + "static/media/auto-tracing.b56cc456.gif";